 function compare () {
        return {
            dataCompareHash: null,
            dataCompareProducts: [],
            compareGlobalLink: document.getElementById('compare-button-global'),
            compareItems: JSON.parse(localStorage.getItem('compareItems')) || [],
            maxItems: parseInt(document.getElementById('compare-global')?.dataset.limit) || 3,
            isOpen: false,
            reachLimit: false,

            async init() {
                const encodedHash = this.getCompareHashFromUrl();

                if (encodedHash) {
                    await this.fetchProductsFromHash(encodedHash).then(() => {
                        this.compareItems = this.dataCompareProducts.map(product => ({
                            id: product.id,
                            title: product.title,
                            handle: product.handle,
                            vendor: product.vendor,
                            url: product.url || product.link,
                            image: product.image
                        }));

                        this.updateLocalStorage();
                        this.updateCompareLink();
                    });
                } else {
                    const stored = JSON.parse(localStorage.getItem('compareItems')) || [];
                    this.compareItems = stored;
                    this.updateCompareLink();

                    this.dataCompareProducts = stored;
                }

                this.checkEmptyElements();

                // console.log(this.dataCompareProducts, ' dataCompareProducts');
                // console.log(this.compareItems, ' compareItems');
            },

            checkEmptyElements() {
                let compareParam = document.querySelectorAll('.product__meta-params');
                let compareMetaInfo = document.querySelectorAll('.product__meta-info');
                let compareMaterial = document.querySelector('.materials--block');
                let compareFeatureList = document.querySelector('.feature-list--block');

                let paramMatrix = [];
                let infoMatrix = [];

                if(compareParam){
                    compareParam.forEach(wrapper => {
                        const params = Array.from(wrapper.querySelectorAll('.product__meta-info-parameter'));
                        paramMatrix.push(params);
                    });

                    const maxParams = Math.max(...paramMatrix.map(params => params.length));

                    for (let i = 0; i < maxParams; i++) {
                        let emptyInAll = true;

                        for (let wrapperParams of paramMatrix) {
                            const param = wrapperParams[i];
                            if (!param || !param.classList.contains('empty')) {
                                emptyInAll = false;
                                break;
                            }
                        }

                        if (emptyInAll) {
                            for (let wrapperParams of paramMatrix) {
                                const param = wrapperParams[i];
                                if (param) {
                                    param.style.display = 'none';
                                }
                            }
                        }
                    }

                    compareParam.forEach(wrapper => {
                        const params = wrapper.querySelectorAll('.product__meta-info-parameter');
                        const allHidden = Array.from(params).every(p => p.style.display === 'none');

                        if (allHidden) {
                            wrapper.closest(".swiper-wrapper").style.display = 'none';
                        }
                    });
                }

                if(compareMetaInfo){
                    compareMetaInfo.forEach(wrapper => {
                        const params = Array.from(wrapper.querySelectorAll('.product__meta-info-item'));
                        infoMatrix.push(params);
                    });

                    const maxInfoItem = Math.max(...infoMatrix.map(params => params.length));

                    for (let i = 0; i < maxInfoItem; i++) {
                        let emptyInAllItems = true;

                        for (let wrapperInfo of infoMatrix) {
                            let param = wrapperInfo[i];
                            if (!param || !param.classList.contains('empty')) {
                                emptyInAllItems = false;
                                break;
                            }
                        }

                        if (emptyInAllItems) {
                            for (let wrapperInfo of infoMatrix) {
                                let param = wrapperInfo[i];
                                if (param) {
                                    param.style.display = 'none';
                                }
                            }
                        }
                    }

                    compareMetaInfo.forEach(item => {
                        let items = item.querySelectorAll('.product__meta-info-item');
                        let allHidden = Array.from(items).every(p => p.style.display === 'none');

                        if (allHidden) {
                            item.closest("[data-slider='swiperMetaInfo']").style.display = 'none';
                        }
                    });
                }

                if (compareMaterial) {
                    const items = compareMaterial.querySelectorAll('.product__meta-materials-header');
                    const allEmpty = Array.from(items).every(item => item.classList.contains('empty'));

                    if (allEmpty) {
                        compareMaterial.closest('.accordion--block').style.display = 'none';
                    }
                }

                if (compareFeatureList) {
                    const items = compareFeatureList.querySelectorAll('.product__meta-feature-list-header');
                    const allEmpty = Array.from(items).every(item => item.classList.contains('empty'));

                    if (allEmpty) {
                        compareFeatureList.closest('.accordion--block').style.display = 'none';
                    }
                }
            },

            async addCompare(product) {
                // console.log(product, ' product');
                if (this.isAdded(product.id)) {
                    this.removeCompare(product.id);
                    this.updateLocalStorage();
                } else if (this.compareItems.length >= this.maxItems) {
                    this.reachLimit = true;
                    setTimeout(() => {
                        this.reachLimit = false;
                    }, 3000);
                } else {
                    this.compareItems.push(product);
                }
                this.updateLocalStorage();
                await this.updateCompareLink();
            },

            removeCompare(productId) {
                this.compareItems = this.compareItems.filter(item => item.id !== productId);
                this.dataCompareProducts = this.dataCompareProducts.filter(item => item.id !== productId);
                this.updateLocalStorage();
                this.updateCompareLink();

                if (this.getCompareHashFromUrl()) {
                    this.updateUrlFromCompareItems();
                }

                if(this.compareItems.length === 0 && this.isOpen === true) {
                    this.isOpen = false;
                }

                setTimeout(
                    () => {
                        this.checkEmptyElements();
                    }, 100
                )
            },

            clearAll(){
                this.compareItems = [];
                this.updateLocalStorage();
                this.updateCompareLink();
                this.isOpen = false;
            },

            isAdded(productId) {
                return this.compareItems.some(item => item.id === productId);
            },

            updateLocalStorage() {
                localStorage.setItem('compareItems', JSON.stringify(this.compareItems));
            },

            async updateCompareLink() {
                if (!this.compareGlobalLink) return;

                const handlesArray = this.compareItems.map(item => item.handle);
                if (handlesArray.length === 0) {
                    this.compareGlobalLink.setAttribute('href', this.compareGlobalLink.dataset.page);
                    return;
                }

                const encoded = this.encodeHandles(handlesArray);
                const newHref = `${this.compareGlobalLink.dataset.page}?compare=${encoded}`;
                this.compareGlobalLink.setAttribute('href', newHref);
            },

            encodeHandles(handles) {
                if (!Array.isArray(handles)) return '';
                const joined = handles.join('&');
                return btoa(encodeURIComponent(joined));
            },

            decodeHandles(encodedData) {
                try {
                    const decodedString = decodeURIComponent(atob(encodedData));
                    return decodedString.split('&');
                } catch (e) {
                    console.log(e);
                    return [];
                }
            },

            updateUrlFromCompareItems() {
                const handlesArray = this.compareItems.map(item => item.handle);

                const url = new URL(window.location.href);
                if (handlesArray.length === 0) {
                    url.searchParams.delete('compare');
                } else {
                    const encoded = this.encodeHandles(handlesArray);
                    url.searchParams.set('compare', encoded);
                }
                history.replaceState(null, '', url);
            },

            getCompareHashFromUrl() {
                const params = new URLSearchParams(window.location.search);
                return params.get('compare') || null;
            },

            async fetchProductsFromHash(encodedData) {
                const handleArr = this.decodeHandles(encodedData);

                // console.log(handleArr, ' handleArr');
                const requests = handleArr.map(handle =>
                    fetch(`/products/${handle}?section_id=main-product`)
                        .then(res => res.text())
                        .then(html => {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, "text/html");

                            const jsonElement = doc.querySelector("#productDataJson");
                            if (!jsonElement) {
                                console.warn(`Not found ${id}`);
                                return null;
                            }

                            try {
                                const parsedJson = JSON.parse(jsonElement.textContent);
                                return parsedJson;
                            } catch (e) {
                                console.error(`${handle}`, e);
                                return null;
                            }
                        })
                );

                const results = await Promise.all(requests);
                this.dataCompareProducts = results.filter(Boolean);
            },

            getMetaValue(metafields, key) {
                const found = metafields.find(m => m.key === key);
                return found ? found.value : '—';
            }
        }
    }

